The identifier for the `PositionOpening`.
